import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import useConfigurationGlobals from "@/composables/useConfigurationGlobals";
import useSettingsGlobals from "@/composables/useSettingsGlobals";

const { $BRAND } = useConfigurationGlobals();
const { $WEB_VIEW } = useSettingsGlobals();

const apiKeys = {
  windalert: import.meta.env.VITE_GOOGLE_MAPS_API_KEY_WINDALERT,
  ikitesurf: import.meta.env.VITE_GOOGLE_MAPS_API_KEY_IKITESURF,
  iwindsurf: import.meta.env.VITE_GOOGLE_MAPS_API_KEY_IWINDSURF,
  sailflow: import.meta.env.VITE_GOOGLE_MAPS_API_KEY_SAILFLOW,
  fishweather: import.meta.env.VITE_GOOGLE_MAPS_API_KEY_FISHWEATHER
}

const webviewApiKeys = {
  windalert: import.meta.env.VITE_GOOGLE_MAPS_API_KEY_WINDALERT_WEBVIEW,
  ikitesurf: import.meta.env.VITE_GOOGLE_MAPS_API_KEY_IKITESURF_WEBVIEW,
  iwindsurf: import.meta.env.VITE_GOOGLE_MAPS_API_KEY_IWINDSURF_WEBVIEW,
  sailflow: import.meta.env.VITE_GOOGLE_MAPS_API_KEY_SAILFLOW_WEBVIEW,
  fishweather: import.meta.env.VITE_GOOGLE_MAPS_API_KEY_FISHWEATHER_WEBVIEW
}

export let useGoogleMapsStore = defineStore('googleMapsStore', () => {
    const brand = $BRAND.toLowerCase();

    const loaded = ref(false);
    const scriptInserted = ref(false);
    const componentCallback = ref(null);

    const apiKey = computed(() => ($WEB_VIEW ? webviewApiKeys[brand] : apiKeys[brand]))

    function loadMaps(callback) {
      if (scriptInserted.value || loaded.value || (window.google && window.google.maps)) {
        mapsLoadedCallback(callback)

        return
      };

      componentCallback.value = callback;

      const googleMapsScript = document.createElement('script')
      googleMapsScript.setAttribute(
        'src',
        `https://maps.googleapis.com/maps/api/js?v=3.65&key=${apiKey.value}&libraries=visualization&callback=mapsLoadedCallback&loading=async`
      )
      googleMapsScript.async = true
      document.head.appendChild(googleMapsScript)

      scriptInserted.value = true;
    }

    function mapsLoadedCallback(callback) {
      loaded.value = true;

      if (callback && typeof callback === 'function') {
        callback();

        return;
      };

      if (componentCallback.value && typeof componentCallback.value === 'function') {
        componentCallback.value();
      }
    }

    window.mapsLoadedCallback = mapsLoadedCallback;

    return {
      loaded,
      loadMaps
    }
});
